import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import { useMutation } from "@apollo/react-hooks";

import gql from "graphql-tag";

export const DODAJ_RASU = gql`
  mutation dodajRasu($rasaInput: RasaInput) {
    dodajRasu(rasaInput: $rasaInput) {
      opis
      napomena
    }
  }
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 600,
      margin: "auto",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 600,
      },
    },
    button: {
      margin: theme.spacing(1),
    },
  })
);

export default function DodajRasu() {
  const resetRase = {
    opis: "",
    napomena: "",
  };

  const classes = useStyles();
  const [dodajRasu] = useMutation(DODAJ_RASU);
  const [buduciPodaci, setBuduciPodaci] = useState(resetRase);

  function dodajPodatkeRase(event: React.FormEvent) {
    event.preventDefault();
    dodajRasu({
      variables: {
        rasaInput: buduciPodaci,
      },
      refetchQueries: ["ucitajRase"],
    });
    setBuduciPodaci(resetRase);
  }

  const onemogucenoDugme = buduciPodaci.opis === "";

  return (
    <form
      className={classes.root}
      noValidate
      autoComplete="off"
      onSubmit={(e: React.FormEvent) => {
        dodajPodatkeRase(e);
      }}
    >
      <div>
        <TextField
          required
          id="opis"
          label="Opis"
          variant="outlined"
          value={buduciPodaci.opis}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
            setBuduciPodaci({ ...buduciPodaci, opis: e.target.value })
          }
        />
        <TextField
          id="napomena"
          label="Napomena"
          variant="outlined"
          fullWidth
          multiline
          rows="4"
          value={buduciPodaci.napomena}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
            setBuduciPodaci({ ...buduciPodaci, napomena: e.target.value })
          }
        />
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          type="submit"
          disabled={onemogucenoDugme}
        >
          Dodaj Rasu
        </Button>
      </div>
    </form>
  );
}
